var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgTipoDeImovel = _a => {
  var _b, _c, _d;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("rect", {
    width: 30,
    height: 1,
    x: 0.667,
    y: 27,
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    rx: 0.5
  }), React.createElement("path", {
    fill: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor',
    d: "M15.7603158,27.9466667 L15.7603158,27.9625282 L8.75333333,27.9625282 L8.75333333,27.9466667 L3.12,27.9466667 L3.12,13 L0.666666667,13 L3.12,4 L28.88,4 L31.3333333,13 L28.88,13 L28.88,27.9466667 L15.7603158,27.9466667 Z M8.75333333,26.9466667 L8.75333333,19.820225 C8.75333333,17.9857288 10.3359519,16.5 12.2572253,16.5 C14.1783849,16.5 15.7603158,17.98563 15.7603158,19.820225 L15.7603158,26.9466667 L27.88,26.9466667 L27.88,13 L4.12,13 L4.12,26.9466667 L8.75333333,26.9466667 Z M9.75333333,26.9466667 L14.7603158,26.9466667 L14.7603158,19.820225 C14.7603158,18.5524429 13.6396519,17.5 12.2572253,17.5 C10.8746086,17.5 9.75333333,18.5526295 9.75333333,19.820225 L9.75333333,26.9466667 Z M3.12,12 L16,12 L28.88,12 L30.0242531,12 L28.1161049,5 L3.88389509,5 L1.97574694,12 L3.12,12 Z M19.0666667,17.2666667 L24.0666667,17.2666667 L24.0666667,22.2666667 L19.0666667,22.2666667 L19.0666667,17.2666667 Z M20.0666667,21.2666667 L23.0666667,21.2666667 L23.0666667,18.2666667 L20.0666667,18.2666667 L20.0666667,21.2666667 Z"
  })));
};
export default SvgTipoDeImovel;